module.exports = __webpack_public_path__ + "static/media/old.33427d4f.svg";